export default {
    state: {
        isSuperAdmin: false
    },
    mutations: {},
    actions: {}
};
